/**
 * Common functionality for the Auth Set password
 */
import SimpleVueValidation from "simple-vue-validator";
import { PASSWORD_VALIDATION } from "@/helpers/constants";
const Validator = SimpleVueValidation.Validator;

export default {
  data() {
    return {
      password: ""
    };
  },
  validators: {
    password(value) {
      return Validator.value(value)
        .required()
        .minLength(8)
        .regex(PASSWORD_VALIDATION.REGEXP, PASSWORD_VALIDATION.ERROR_MESSAGE);
    }
  },
  methods: {
    async setNewPassword() {
      if (this.validation.hasError("password")) {
        return;
      }

      let { success, messages, errors, user } = await this.$store.dispatch("users/setNewPassword", {
        password: this.password
      });

      this.showMessages(messages);
      this.showErrors(errors);

      if (success && user) {
        await this.redirectUser(user);
      }
    }
  }
};
